import { Grid } from '@material-ui/core';
import { PrimaryButton, Text, SecondaryButton, Colors } from 'library';
import React, { useState, useEffect } from 'react';
import EmailIcon from '@material-ui/icons/Email';
import { bounceInLeft } from 'react-animations';
import { StyleSheet, css } from 'aphrodite';
import { track } from 'shared';

interface IProps {
    sendAction: () => void;
    closeAction: () => void;
    sentTo: string;
}
export default function InviteSent({ sendAction, closeAction, sentTo }: IProps) {
    const animations = StyleSheet.create({
        bounceInLeft: {
            animationName: bounceInLeft,
            animationDuration: '1s',
        },
    });

    function sendAnother() {
        track('Groups: Send Another Clicked on Invite By Email');
        sendAction();
    }

    function close() {
        track('Groups: Close Clicked on Invite By Email');
        closeAction();
    }

    return (
        <Grid container direction="column" spacing={3}>
            <Grid container item justify="center">
                <Text variant="h1" bold>
                    Invite By Email
                </Text>
            </Grid>
            <Grid container item justify="center">
                <Grid item className={css(animations.bounceInLeft)}>
                    <EmailIcon color={'primary'} style={{ fontSize: '72' }} />
                </Grid>
            </Grid>
            <Grid container item direction="column" alignItems="center">
                <Grid item>
                    <Grid container>
                        <Text variant="body1">
                            Invite Email sent successfully to{' '}
                            <Text variant="body1" bold>
                                {sentTo}
                            </Text>
                        </Text>
                    </Grid>
                </Grid>
            </Grid>
            <Grid container item justify="center" spacing={3}>
                <Grid item>
                    <PrimaryButton onClick={sendAnother}>Send Another</PrimaryButton>
                </Grid>
                <Grid item>
                    <SecondaryButton onClick={close}>Close</SecondaryButton>
                </Grid>
            </Grid>
        </Grid>
    );
}
